export default [
  {
    path: "/download",
    props: true,
    component: () => import("../Download.vue")
  }
]
